import { useEffect, useRef, useState } from "react";

export const useWiggleAnimation = (enabled = false) => {
	const animationSingleton = useRef(null);
	const [isWiggling, setIsWiggling] = useState(false);

	useEffect(() => {
		if (enabled) {
			if (!animationSingleton.current) {
				const animate = async () => {
					while (true) {
						setIsWiggling(false);
						// eslint-disable-next-line no-undef
						await new Promise((resolve) => setTimeout(resolve, 3000));
						setIsWiggling(true);
						// eslint-disable-next-line no-undef
						await new Promise((resolve) => setTimeout(resolve, 300));
					}
				};

				animate();
				animationSingleton.current = true;
			}
		}
	}, [enabled]);

	return { isWiggling };
};
